<script setup>
import { dirtyFieldMixin } from '@/mixins/dirtyFieldMixin'
import DataField from '@/components/form/DataField.vue'
import { computed, ref } from 'vue'
import { useStore } from 'vuex'

const { dirtyItems, addDirty, getDirtyClass } = dirtyFieldMixin()

const store = useStore()

const currentItem = computed(() => store.state.burstingParameterRevision.currentItem)

const setNestedParameter = (payload) => {
  store.dispatch('burstingParameterRevision/setNestedParameter', payload)
}

const update = () => store.dispatch('burstingParameterRevision/update')

const emptyDirtyItems = () => store.dispatch('burstingParameterRevision/emptyDirtyItems')
const toggleWriteLoading = () => store.dispatch('burstingParameterRevision/toggleWriteLoading')
const table = ref(null)

const saveChanges = () => {
  try {
    update()
    emptyDirtyItems()
    dirtyItems.value = []
    table.value.saveChanges()
  } catch (e) {
    toggleWriteLoading()
  }
}

defineExpose({
  saveChanges
})
</script>

<template>
  <v-row>
    <v-col cols="3">
      <DataField
        label="Water level drop [m]"
        @update="addDirty(currentItem, 'water_level_drop')"
        @set="setNestedParameter"
        density="default"
        :classField="getDirtyClass(currentItem, 'water_level_drop')"
        parameter="water_level_drop"
        :item="currentItem"
      >
      </DataField>
    </v-col>
    <v-col cols="3">
      <DataField
        label="Strength reduction max thickness [m]"
        @update="addDirty(currentItem, 'strength_reduction_max_thickness')"
        @set="setNestedParameter"
        density="default"
        :classField="getDirtyClass(currentItem, 'strength_reduction_max_thickness')"
        parameter="strength_reduction_max_thickness"
        :item="currentItem"
      >
      </DataField>
    </v-col>
    <v-col cols="3">
      <DataField
        label="Reduction in bursting head limit [m]"
        @update="addDirty(currentItem, 'reduction_in_bursting_head_limit')"
        @set="setNestedParameter"
        density="default"
        :classField="getDirtyClass(currentItem, 'reduction_in_bursting_head_limit')"
        parameter="reduction_in_bursting_head_limit"
        :item="currentItem"
      >
      </DataField>
    </v-col>
  </v-row>
</template>
